import { Link, useLocation } from "react-router-dom";
import "../Styles/Navbar.css";
import GoogleTranslator from "./GoogleTranslator";
import logo from "../Assests/logo1.png";

function Navbar() {
    const location = useLocation();

    return (
        <header className="temple-header">

            {/* Top Section */}
            <div className="top-header container-fluid">

                {/* Logo */}
                <div className="logo-section">
                    <img
                        src={logo}
                        alt="Temple Logo"
                        className="temple-logo"
                    />
                </div>

                {/* Temple Name */}
                <div className="title-section">

                    <h1>Nambooriyachan Aalkshethra Sevasamithi</h1>

                    <p>
                        <b>RegNo: EKM/TC/544/2014</b>
                    </p>

                    <p>
                        "Faith • Devotion • Tradition"
                    </p>

                </div>

                {/* Back Button */}
                <div className="back-section">

                    {location.pathname !== "/" && (
                        <Link
                            to="/"
                            className="back-btn"
                        >
                            <i className="bi bi-arrow-left-circle"></i>
                            Back
                        </Link>
                    )}

                </div>

            </div>

            {/* Navigation */}
            <nav className="navbar navbar-expand-lg navbar-dark temple-navbar">

                <div className="container">

                    <button
                        className="navbar-toggler"
                        data-bs-toggle="collapse"
                        data-bs-target="#menu"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div
                        className="collapse navbar-collapse justify-content-center"
                        id="menu"
                    >

                        <ul className="navbar-nav">

                            {/* ABOUT */}
                            <li className="nav-item">
                                <Link
                                    className="nav-link"
                                    to="/about"
                                >
                                    About
                                </Link>
                            </li>

                            {/* POOJAS */}
                            <li className="nav-item">
                                <Link
                                    className="nav-link"
                                    to="/poojas"
                                >
                                    Poojas
                                </Link>
                            </li>

                            {/* FESTIVALS */}
                            <li className="nav-item">
                                <Link
                                    className="nav-link"
                                    to="/festivals"
                                >
                                    Festivals
                                </Link>
                            </li>

                            {/* GALLERY DROPDOWN */}
                            <li className="nav-item dropdown">

                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="/gallery"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Gallery
                                </Link>

                                <ul className="dropdown-menu">

                                    <li>
                                        <Link
                                            className="dropdown-item"
                                            to="/gallery/photos"
                                        >
                                            📷 Photos
                                        </Link>
                                    </li>

                                    <li>
                                        <Link
                                            className="dropdown-item"
                                            to="/gallery/videos"
                                        >
                                            🎥 Videos
                                        </Link>
                                    </li>

                                    <li>
                                        <Link
                                            className="dropdown-item"
                                            to="/gallery/media-tv"
                                        >
                                            📺 Media TV
                                        </Link>
                                    </li>

                                </ul>

                            </li>

                            {/* CONTACT */}
                            <li className="nav-item">
                                <Link
                                    className="nav-link"
                                    to="/contact"
                                >
                                    Contact
                                </Link>
                            </li>

                            {/* COMMITTEE */}
                            <li className="nav-item">
                                <Link
                                    className="nav-link"
                                    to="/Committee"
                                >
                                    Committee
                                </Link>
                            </li>

                            {/* GOOGLE TRANSLATOR */}
                            <li className="nav-item translator-item">
                                <GoogleTranslator />
                            </li>

                        </ul>

                    </div>

                </div>

            </nav>

        </header>
    );
}

export default Navbar;
